import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { ADMIN_ROLE } from './auth-context'
import { useAuth } from './useAuth'

/**
 * Gate in front of every application route.
 *
 * An unauthenticated visitor is sent to the login screen with the page they
 * wanted recorded, so signing in returns them there instead of dumping them on
 * the overview. This is a usability guard, not the security boundary — the API
 * rejects unauthorised calls regardless of what the browser renders.
 */
export function ProtectedRoute() {
  const { isAuthenticated, session } = useAuth()
  const location = useLocation()

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />
  }

  if ((session?.role ?? '').toUpperCase() !== ADMIN_ROLE) {
    return <Navigate to="/forbidden" replace />
  }

  return <Outlet />
}
